import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18aa447f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "sectors" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "80",
  width: "21",
  y: "-106",
  height: "11"
}, null, -1))
const _hoisted_3 = {
  x: "100",
  y: "-100",
  "text-anchor": "end"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "-101",
  width: "50",
  y: "-106",
  height: "11"
}, null, -1))
const _hoisted_5 = {
  x: "-100",
  y: "-100",
  "text-anchor": "start"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "-101",
  width: "30",
  y: "95",
  height: "11"
}, null, -1))
const _hoisted_7 = {
  x: "-100",
  y: "101",
  "text-anchor": "start"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "50",
  width: "40",
  y: "95",
  height: "11"
}, null, -1))
const _hoisted_9 = {
  x: "87",
  y: "101",
  "text-anchor": "end"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("g", _hoisted_1, [
    (_ctx.showSectors[0])
      ? (_openBlock(), _createElementBlock("g", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('zoom-sector', 1, -1)))
        }, [
          _hoisted_2,
          _createElementVNode("text", _hoisted_3, _toDisplayString(_ctx.langIsGerman() ? _ctx.Sectors[0] : _ctx.SectorsEng[0]), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.showSectors[1])
      ? (_openBlock(), _createElementBlock("g", {
          key: 1,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('zoom-sector', -1, -1)))
        }, [
          _hoisted_4,
          _createElementVNode("text", _hoisted_5, _toDisplayString(_ctx.langIsGerman() ? _ctx.Sectors[1] : _ctx.SectorsEng[1]), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.showSectors[2])
      ? (_openBlock(), _createElementBlock("g", {
          key: 2,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('zoom-sector', -1, 1)))
        }, [
          _hoisted_6,
          _createElementVNode("text", _hoisted_7, _toDisplayString(_ctx.langIsGerman() ? _ctx.Sectors[2] : _ctx.SectorsEng[2]), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.showSectors[3])
      ? (_openBlock(), _createElementBlock("g", {
          key: 3,
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('zoom-sector', 1, 1)))
        }, [
          _hoisted_8,
          _createElementVNode("text", _hoisted_9, _toDisplayString(_ctx.langIsGerman() ? _ctx.Sectors[3] : _ctx.SectorsEng[3]), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}